import { render, staticRenderFns } from "./UserAction.vue?vue&type=template&id=70981421&scoped=true&lang=html"
import script from "./UserAction.vue?vue&type=script&lang=js"
export * from "./UserAction.vue?vue&type=script&lang=js"
import style0 from "./UserAction.vue?vue&type=style&index=0&id=70981421&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70981421",
  null
  
)

export default component.exports